import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private _document$ = new BehaviorSubject<File | null>(null);

  cache(document: File) {
    this._document$.next(document);
  }

  get cachedDocument$(): Observable<File | null> {
    return this._document$.asObservable();
  }

  get cachedDocument(): File | null {
    return this._document$.value;
  }
}
